export const SUPPORTED_CURRENCIES = [
  "CLP",
  "PEN",
  "ARS",
  "COP",
  "USD",
  "BRL",
] as const;

export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number];

export function isCurrencyCode(value: unknown): value is CurrencyCode {
  return (
    typeof value === "string" &&
    (SUPPORTED_CURRENCIES as readonly string[]).includes(value)
  );
}

export function toCurrencyCode(
  value: string | null | undefined,
): CurrencyCode | null {
  if (!value) return null;
  return isCurrencyCode(value) ? value : null;
}
